import { Popover, PopoverTitle, PopoverContent } from 'react-bootstrap';
import React from 'react';
import { WORKFLOW_STEP_TYPES } from '../../../../global/constants';
import { calculateAllocationPercent } from '../../services/utils';

//Used forwardRef to position pop over - https://github.com/react-bootstrap/react-bootstrap/issues/2627
export const WorkflowResourcePopOver = React.forwardRef((props, ref) => {
  const node = props.node;
  const params = node.parameters;

  const resourceInfo = [];
  switch (node.type) {
    case WORKFLOW_STEP_TYPES.TranslationMemory:
      resourceInfo.push(`${params.tmLookupTableName}: ${params.tmIdentifier}`);
      break;
    case WORKFLOW_STEP_TYPES.MachineTranslation:
      if (params.type === 'AMT') {
        resourceInfo.push(
          params.preferredSourceLocale
            ? `${params.type}: ${params.preferredSourceLocale}-${params.preferredTargetLocale}`
            : `${params.type}`
        );
      } else {
        resourceInfo.push(
          params.modelVariant
            ? `${params.type}: ${params.modelName}-${params.modelVariant}`
            : `${params.type}: ${params.modelName}`
        );
      }
      break;
    case WORKFLOW_STEP_TYPES.TerminologyBase:
      resourceInfo.push(`${params.tableName}: ${params.termIdentifier}`);
      break;
    case WORKFLOW_STEP_TYPES.Luma:
      if (params.modelId) {
        resourceInfo.push(`Model: ${params.modelId}`);
      }
      if (params.promptId) {
        resourceInfo.push(`Prompt: ${params.promptId}`);
      }
      if (params.translationType) {
        resourceInfo.push(`Type: ${params.translationType}`);
      }
      break;
    case WORKFLOW_STEP_TYPES.AB:
      for (const allocation of params.allocations) {
        const percent = calculateAllocationPercent(allocation, params.buckets);
        resourceInfo.push(`${allocation.name}: ${percent}%`);
      }
      break;
    default:
      break;
  }

  return (
    <Popover {...props} ref={ref}>
      <PopoverTitle>Resource Detail</PopoverTitle>
      <PopoverContent>
        {resourceInfo.map(entry => (
          <div>{entry}</div>
        ))}
      </PopoverContent>
    </Popover>
  );
});
